import React, { useState, useEffect } from "react";
import { API_URL_FOR_IMG } from "../../service/CategoryService";
import { Button, Form } from "react-bootstrap";
import { apiUrl } from "../../config";

const CategoryForm = ({ initialValues, onSubmit, onCancel }) => {
  const [formData, setFormData] = useState({
    id: "",
    code: "",
    name: "",
    imageUrl: null,
  });
  const [preview, setPreview] = useState(null);
  const [file, setFile] = useState(null);

  // Reset form when initialValues changes
  useEffect(() => {
    if (initialValues) {
      setFormData({
        id: initialValues.id,
        code: initialValues.code,
        name: initialValues.name,
        imageUrl: initialValues.imageUrl,
      });
      setPreview(initialValues.imageUrl ?apiUrl+ "/"+initialValues.imageUrl : null);
    } else {
      setFormData({ id: "", code: "", name: "", imageUrl: null });
      setPreview(null);
      setFile(null);
    }
  }, [initialValues]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const uploadedFile = e.target.files[0];
    if (uploadedFile) {
      setFile(uploadedFile);
      setPreview(URL.createObjectURL(uploadedFile));
    }
  };
  const handleSubmit = (e) => {
  e.preventDefault();

  const data = {
    ...formData,
    file
  };

  onSubmit(data);
};

  return (
    <Form onSubmit={handleSubmit}>
  <Form.Group className="mb-3">
    <Form.Label>Code <span style={{color:'red'}}>*</span></Form.Label>
    <Form.Control
      type="text"
      name="code"
      value={formData.code}
      onChange={handleChange}
      required
      placeholder="Enter category code"
    />
  </Form.Group>

  <Form.Group className="mb-3">
    <Form.Label>Name <span style={{color:'red'}}>*</span></Form.Label>
    <Form.Control
      type="text"
      name="name"
      value={formData.name}
      onChange={handleChange}
      required
      placeholder="Enter category name"
    />
  </Form.Group>

  <Form.Group className="mb-3">
    <Form.Label>Image <span style={{color:'red'}}>*</span></Form.Label>
    <Form.Control type="file" accept="image/*" onChange={handleImageChange} required={initialValues ? false : true}/>
    {preview && (
      <div className="mt-3">
        <img
          src={preview}
          alt="Preview"
          width="100"
          height="100"
          className="rounded border"
          style={{ objectFit: "cover" }}
        />
      </div>
    )}
  </Form.Group>

  <div className="text-end mt-4">
    <Button variant="secondary" className="me-2" onClick={onCancel}>
      Cancel
    </Button>
    <Button variant="primary" type="submit">
      {initialValues ? "Update" : "Submit"}
    </Button>
  </div>
</Form>

  );
};

export default CategoryForm;